import { theme } from "../../utils/theme";

export const styles = {
  background: {
    backgroundColor: theme.palette.grays["white"],
    backgroundPosition: "left bottom !important",
    backgroundRepeat: "no-repeat !important",
    backgroundSize: "cover !important",
    // filter: "brightness(0.3) grayscale(0.8) hue-rotate(300deg)",
    height: "100%",
    left: { xs: 0, sm: 0 },
    top: { xs: 0, sm: 0 },
    position: "absolute",
    width: { xs: "220%", sm: "120%" },
    zIndex: 1,
  },
  body: {
    alignItems: "center",
    // height: "100%",
    overflow: "hidden",
    position: "relative",
    width: "100%",
    zIndex: 2,
  },
  content: {
    color: theme.palette.grays[900],
    fontSize: theme.typography.body,
    fontWeight: 300,
    px: 4,
    textAlign: { xs: "center", md: "center" },
    textTransform: "none",
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  margin: {
    display: "flex",
    margin: 1,
  },
  root: {
    alignItems: { xs: "center", md: "center" },
    gap: 12,
    // height: { sm: "100vh", md: "88vh" },
    justifyContent: "start",
    overflow: "hidden",
    pb: { xs: 14, md: 12 },
    pt: { xs: 10, md: 24 },
    position: "relative",
    width: "100%",
  },
};
